import { render, staticRenderFns } from "./StatusPedido.vue?vue&type=template&id=77e87188"
import script from "./StatusPedido.vue?vue&type=script&lang=js"
export * from "./StatusPedido.vue?vue&type=script&lang=js"
import style0 from "./StatusPedido.vue?vue&type=style&index=0&id=77e87188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports